import { h, Component, Fragment } from "preact";
import "./library.scss";
import Api, { SmallWork, WorkChangeTypes, FullWork } from "../../api";
import { WorkComponent } from "./work";

import { Plus, Search, Edit } from "preact-feather";
import Navigation, { Pages } from "../../navigation";
import { showModal } from "../../modal";
import { useState, useRef } from "preact/hooks";
import Fab from "./fab";

// import ScrollViewport from "preact-scroll-viewport";
// import VirtualList from "../../virtual_scroll";
// import VirtualList from "preact-virtual-list/src/index.js";

function showAddModal() {
   const controls = showModal(() => {
      const [loading, setLoading] = useState(false);
      const [message, setMessage] = useState("");
      const [error, setError] = useState(undefined);

      const textInput = useRef<HTMLInputElement>();

      const addFromFile = async (file: File) => {
         if (file.name.endsWith(".epub")) {
            console.log("Epub found!");
            try {
               await Api.addEPub(file);
            } catch (e) {
               alert(
                  "Some error occured, please try again later: " + e.message
               );
            }
         } else {
            await new Promise<void>((yes, no) => {
               let r = new FileReader();
               r.onload = async (e) => {
                  try {
                     setLoading(true);
                     let content: string = (e.target as any).result;
                     let wks = content
                        .split("\n")
                        .map((e) => e.trim())
                        .filter((e) => e !== "");
                     let current = 0;
                     let drawpg = () => {
                        setMessage(`Converted ${current} from ${wks.length}`);
                     };
                     drawpg();
                     for (let w of wks) {
                        await Api.addWorkFromUrl(w);
                        current++;
                        drawpg();
                     }
                  } catch (e) {
                     alert(
                        "Some error occured, please try again later: " +
                        e.message
                     );
                  } finally {
                     yes();
                  }
               };
               r.readAsText(file);
            });
         }
      };

      const fileSelectedHandler = async (evt) => {
         let files: File[] = (evt.target as any).files;
         setLoading(true);
         try {
            for (let file of files) {
               setMessage("Uploading " + file.name);
               await addFromFile(file);
            }
            controls.close();
         } catch (e) {
            alert("Failed to load file");
         }
         setMessage("");
         setLoading(false);
         (evt.target as HTMLInputElement).value = null;
      };

      const addFromUrl = async (evt: MouseEvent) => {
         setMessage("Working");
         setLoading(true);
         let url = textInput.current.value;
         if (url)
            await Api.addWorkFromUrl(url)
               .then(() => {
                  if (textInput.current) textInput.current.value = null;
                  controls.close();
               })
               .catch((err) => alert(err.message));

         setMessage("");
         setLoading(false);
      };

      return (
         <Fragment>
            <div className="modal-title">Add</div>
            <div className="modal-content">
               {loading ? (
                  <div
                     id="add_work_loader"
                     style="display:{{#if loader_visibility}}block{{else}}none{{/if}};"
                  >
                     <h3>{message}</h3>
                     <div style="width: 65px; height: 65px; margin: 0 auto;">
                        <svg
                           class="spinner"
                           viewBox="0 0 66 66"
                           xmlns="http://www.w3.org/2000/svg"
                        >
                           <circle
                              class="circle"
                              fill="none"
                              stroke-width="6"
                              stroke-linecap="round"
                              cx="33"
                              cy="33"
                              r="30"
                           ></circle>
                        </svg>
                     </div>
                  </div>
               ) : (
                  <div>
                     <div class="input-group">
                        <label for="url">Enter URL of work</label>
                        <input
                           type="text"
                           id="url"
                           name="url"
                           autofocus
                           value={textInput?.current?.value}
                           ref={textInput}
                        />
                        <div class="error invisible" id="url_error"></div>
                     </div>
                     <div class="group">
                        <input
                           class="btn"
                           id="add_wp_book_bulk"
                           type="file"
                           multiple
                           onChange={fileSelectedHandler}
                        />
                     </div>
                     <button
                        id="add_work_save"
                        type="submit"
                        class="btn"
                        onClick={addFromUrl}
                     >
                        Add
                     </button>
                  </div>
               )}
            </div>
         </Fragment>
      );
   });
}

export interface DisplayWork extends SmallWork {
   disabled: boolean;
   reload: boolean;
   finished: boolean;
}

export interface LibraryProps { }
interface LibraryState {
   // search: string;
   // modal_message: string;
   // add_modal_visibility: boolean;
   // loader_visibility: boolean;
   searchWorks: SmallWork[];
   noFinished: boolean;
}
export class LibraryComponent extends Component<LibraryProps, LibraryState> {
   private works: SmallWork[] = [];
   private _search: string = "";
   private rowHeight = 340.4;

   set search(value: string) {
      value = value.toLowerCase();
      if (this._search !== value) {
         let full = true;
         if (value.startsWith(this._search)) full = false;
         this._search = value;
         let filtered = this.filter(full);
         this.setState({ searchWorks: this.resort(filtered) });
      }
   }

   get search() {
      return this._search;
   }

   constructor() {
      super();
      this.state = {
         searchWorks: [],
         noFinished: true,
      };
      this.onChange = this.onChange.bind(this);
   }

   onChange(events: { type: WorkChangeTypes; work: FullWork }[]) {
      events.forEach(({ type, work }) => {
         switch (type) {
            case WorkChangeTypes.position:
            case WorkChangeTypes.create_edit: {
               let idx = this.works.findIndex((e) => e._id === work._id);
               if (idx < 0) {
                  type
                  this.works.push(work);
               } else {
                  this.works[idx] = work;
               }
               break;
            }
            case WorkChangeTypes.delete: {
               let idx = this.works.findIndex((e) => e._id === work._id);
               if (idx >= 0) {
                  this.works.splice(idx, 1);
               }
               break;
            }
         }
      });
      let filtered = this.filter(true);
      this.setState({ searchWorks: this.resort(filtered) });
   }

   componentWillMount() {
      Api.workObservable.subscribeCollect(this.onChange);
      Api.getWorks().then((works) => {
         this.works = works;
         let filtered = this.filter(true);
         this.setState({ searchWorks: this.resort(filtered) });
      });
   }

   componentWillUnmount() {
      Api.workObservable.unsubscribe(this.onChange as any);
   }

   private filter(full: boolean) {
      if (!this.search || this.search === "") return this.works;
      else {
         let works = full ? this.works : this.state.searchWorks;

         let search = this.search;

         let onlyAuthor = false;
         let onlyTags = false;
         if (search.startsWith("@")) {
            onlyAuthor = true;
            search = search.slice(1, search.length);
         } else if (search.startsWith("#")) {
            onlyTags = true;
            search = search.slice(1, search.length);
         }
         // console.log(search, onlyAuthor, onlyTags);
         let parts = search.split(" ");

         let getVals = (e: SmallWork) => {
            let arr: string[] = [];
            if (onlyAuthor) {
               arr = [e.author];
            } else if (onlyTags) {
               arr = e.tags;
            } else {
               arr = [e.author, e.title, e.summary].concat(e.tags);
            }
            return arr;
         };

         const match = (text: string) =>
            parts.every((el) => text.toLowerCase().indexOf(el) > -1);
         const any = (parts: string[]) => parts.findIndex((e) => match(e)) > -1;

         return works.filter((e) => any(getVals(e)));
      }
   }

   private resort(works: SmallWork[]) {
      return works.sort((e1, e2) => {
         // Works with position are higher ranked that these without.
         // The next parameter is the date of last read.
         // if (!e1.position && !e2.position) {
         //    return new Date(e2.creation_date).getTime() - new Date(e1.creation_date).getTime();
         // } else if (!e1.position) return -1;
         // else if (!e2.position) return 1;
         const e1Finished = e1.progress >= Api.finishedLimit;
         const e2Finished = e2.progress >= Api.finishedLimit;

         if (e1Finished !== e2Finished) {
            if (e1Finished) return 1;
            if (e2Finished) return -1;
         }

         let d1 = e1.position ? e1.position.date : e1.creation_date;
         let d2 = e2.position ? e2.position.date : e2.creation_date;
         return new Date(d2).getTime() - new Date(d1).getTime();
      });
   }

   render(props: LibraryProps, state: LibraryState) {
      let wks = state.searchWorks;
      if (state.noFinished)
         wks = state.searchWorks.filter((e) => e.progress < Api.finishedLimit);

      let works = wks.map((work) => {
         let w: DisplayWork = {
            ...work,
            disabled: false,
            reload: work.type === "ao3" || work.type === "wattpad",
            finished:
               (Number.isNaN(work.progress) ? 0 : work.progress) >=
               Api.finishedLimit,
         };

         return (
            <div
               key={w._id}
               class="col col-4 col-sm-4 col-md-3 col-lg-2 col-xl-2"
            >
               <WorkComponent id={work._id} work={w} />
            </div>
         );
      });

      return (
         <div>
            <div class={"container library_container"}>
               <div class="row">
                  <div class="col-sm-12">
                     <input
                        class="inp elv-4 libary_input"
                        type="text"
                        name="search"
                        placeholder="Search"
                        aria-label="search"
                        onKeyUp={(evt) => {
                           this.search = (evt.target as HTMLInputElement).value;
                        }}
                     />
                  </div>
               </div>
               <div id="library_works" class="row">
                  {works}
               </div>
               <div class="row">
                  <div class="col-sm-12" style="display: flex;">
                     <button
                        class="btn btn-primary"
                        style="margin:auto"
                        onClick={() =>
                           this.setState({ noFinished: !this.state.noFinished })
                        }
                     >
                        {this.state.noFinished ? "List" : "Hide"} Finished
                     </button>
                  </div>
               </div>
            </div>

            <Fab
               icon={<Plus />}
               items={[
                  {
                     icon: <Plus />,
                     onClick: () => showAddModal(),
                     label: "Add",
                  },
                  {
                     icon: <Search />,
                     onClick: () => Navigation.setPage(Pages.Browse, undefined),
                     label: "Browse",
                  },
                  {
                     icon: <Edit />,
                     onClick: () => Navigation.setPage(Pages.Edit, undefined),
                     label: "Add manually",
                  },
               ]}
            />
            {/* <a
                  style="color:white;"
                  aria-label="add"
                  onClick={(evt) =>
                     (evt.preventDefault() as any) || showAddModal()
                  }
               >
                  <Plus />
               </a>
               <a
                  style={{ color: "white" }}
                  aria-label="browse"
                  onClick={(evt) => {
                     evt.preventDefault();
                  }}
               >
                  <Search />
               </a>
            </Fab> */}
         </div>
      );
   }
}

// function AddButtons() {
//    return ;
// }
